import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface TypeComunicationPecListComponentProps {
  disabled?: boolean;
  value?: string;
  onChange: (state: string) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
  id?: string;
  ambito?: string;
}

type TypeComunicationPecListModel = {
  key: {
    codComunicazione: string;
  };
  codiceOperatoreInserimento: string;
  timestampInserimento: string;
  codiceOperatoreUltimoAggiornamento: string;
  timestampUltimoAggiornamento: string;
  note: string;
  descComunicazione: string;
  testoNote: string;
};

const ListTypeComunicationComponent = ({
  disabled,
  onChange,
  value,
  required,
  error,
  label = 'Tipo comunicazione',
  id = 'type-comunication-pec',
  ambito = 'PEC',
}: TypeComunicationPecListComponentProps): React.ReactElement => {
  const [typeComunicationList] = useHttpFetch<
    HttpResponseListPayloadQuarkus<TypeComunicationPecListModel>,
    Array<ItemVM>
  >(`${__ACT_API_URL__}/comunicazione/${ambito}`, {
    onBootstrap: true,
    initialData: [],
    transformer: (
      response: AxiosResponse<HttpResponseListPayloadQuarkus<TypeComunicationPecListModel>>
    ) => {
      const { data } = response;

      return data?.payload?.map((item) => ({
        id: item.key.codComunicazione,
        value: `${item.key.codComunicazione || ''} - ${item.descComunicazione || ''}`,
      })) as Array<ItemVM>;
    },
  });

  const list = (typeComunicationList.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value || ''}
        label={required ? `${label} *` : label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeComunicationComponent.displayName = 'Type comunication List component';

const ListTypeComunication = memo(ListTypeComunicationComponent);

export default ListTypeComunication as typeof ListTypeComunicationComponent;
